/* =========================================================================
   VD TRACK — shared front-end event emitter
   Load FIRST in layout/theme.liquid, before every other vd-*.js:
     <script src="{{ 'vd-track.js' | asset_url }}" defer></script>

   WHAT THIS IS
   ------------
   A messenger, nothing else. Something happens on the page, this shouts it.
   It does not store, aggregate, batch, or make network requests of its own.
   Measured cost on this store: 0.0113 ms per call. A page load is ~1,880 ms.

   WHY IT IS A SEPARATE FILE
   -------------------------
   vd-cart-drawer.js already contains a private copy of this logic. Copying it
   a second time into vd-collection.liquid is exactly the mistake documented at
   the top of vd-grid-engine.js:

     "Replaces two hand-copied engines that drifted (root cause of the
      Load-more scroll-jump saga: a fix landed in one copy and not the other)."

   So the shared home is created correctly from day one. The cart drawer keeps
   its private copy until the Monday A/B has settled, then deletes it and calls
   VDTrack.emit instead — a delete-and-point change, verified on its own.

   WHERE THE EVENTS GO
   -------------------
   1. document CustomEvent  'vd:<ns>:<name>'   — anything running in the page
   2. window.dataLayer                          — GTM
   3. Shopify.analytics.publish                 — Shopify Web Pixels. REQUIRED:
        pixels run in a sandboxed iframe and can NEVER see the CustomEvent.
   4. window.igEvents                           — Intelligems. IG runs in the
        page and drains this queue itself, so no endpoint and no pixel needed.
        Every name must be registered once in IG > Events Manager before it can
        be used as a metric. Identifiers are capped at 100 characters.
   ========================================================================= */
(function (w, d) {
  if (w.VDTrack) return;                         // idempotent: never double-install

  /* ---- session id: lets a funnel be de-duplicated to unique sessions ---- */
  var SKEY = 'vd_sid';
  function sid() {
    try {
      var v = sessionStorage.getItem(SKEY);
      if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem(SKEY, v); }
      return v;
    } catch (e) { return ''; }                   // private mode / storage blocked
  }

  /* ---- context every event carries, resolved once ---- */
  var CTX = null;
  function ctx() {
    if (CTX) return CTX;
    CTX = {
      sid: sid(),
      tpl: (w.Shopify && w.Shopify.designMode) ? 'editor' : (d.body && d.body.getAttribute('data-template')) || '',
      dev: (w.innerWidth || 0) < 750 ? 'mobile' : 'desktop'
    };
    return CTX;
  }

  /* ---- Largest Contentful Paint, for separating "faster" from "better" ----
     The PLP A/B removes a 420px hero image that is very likely the LCP element.
     Without this field a win reads as "the layout is better" when the real
     cause may be "one big image fewer". Read lazily: LCP is not final at load. */
  var LCP = null;
  try {
    // Chrome only surfaces LCP entries to code that OBSERVES them.
    // getEntriesByType('largest-contentful-paint') alone always returns [].
    new PerformanceObserver(function (list) {
      var e = list.getEntries();
      if (e.length) LCP = Math.round(e[e.length - 1].startTime);
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (err) {}
  function lcp() { return LCP; }

  /* ---- the one function everything else calls ---- */
  function emit(ns, name, detail) {
    var full = 'vd_' + ns + '_' + name;
    var payload = detail || {};
    var c = ctx();
    payload.sid = c.sid;
    payload.dev = c.dev;
    payload.ts = Date.now();

    try { d.dispatchEvent(new CustomEvent('vd:' + ns + ':' + name, { detail: payload, bubbles: true })); } catch (e) {}
    try { (w.dataLayer = w.dataLayer || []).push(Object.assign({ event: full }, payload)); } catch (e) {}
    try {
      if (w.Shopify && w.Shopify.analytics && w.Shopify.analytics.publish) w.Shopify.analytics.publish(full, payload);
    } catch (e) {}
    try {
      w.igEvents = w.igEvents || [];
      w.igEvents.push({ event: full, dev: payload.dev, variant: payload.variant });
    } catch (e) {}

    return payload;
  }

  /* ---- click delegation ----------------------------------------------------
     ALWAYS delegate from document. Product cards are woven by vd-grid-engine.js,
     which diff-syncs the grid in place on Load more — listeners bound directly
     to a card silently die when that card is re-positioned. Delegation also
     means one listener instead of 48. */
  function onClick(selector, fn) {
    d.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var el = t.closest(selector);
      if (el) { try { fn(el, ev); } catch (e) {} }
    }, true);                                    // capture: fires before any handler that stops propagation
  }

  /* ---- index of an element among its matching siblings (1-based) ----
     "Which position did they click?" is how we detect that removing the banner
     pulled more products above the fold. */
  function posOf(el, selector) {
    var all = d.querySelectorAll(selector);
    for (var i = 0; i < all.length; i++) if (all[i] === el) return i + 1;
    return 0;
  }

  w.VDTrack = { emit: emit, onClick: onClick, posOf: posOf, lcp: lcp, ctx: ctx, sid: sid };
})(window, document);
